import React from 'react';
interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
}
export const inputClass = 'h-12 w-full border border-line bg-paper px-3.5 text-[15px] text-ink placeholder:text-mute/70 transition-colors duration-150 focus:border-ink focus:outline-none aria-[invalid=true]:border-ember';
export function FormField({
  id,
  label,
  required,
  error,
  children
}: FormFieldProps) {
  return <div data-id="element-146" data-mp="2cc47nphv5ceo">
      <label htmlFor={id} className="mb-2 block text-sm font-medium" data-id="element-147" data-mp="2ccckjhdzkhpv">
        {label}
        {required && <span className="text-ember" data-id="element-148" data-mp="2haxpfu46npkn"> *</span>}
      </label>
      {children}
      {error && <p id={`${id}-error`} role="alert" className="mt-1.5 text-sm text-ember-dark" data-id="element-149" data-mp="2l8vf0y1v8dok">
          {error}
        </p>}
    </div>;
}